<template>
  <app-layout>
    <template #header>
      <div class="flex items-center">
        <div class="flex-1">
          <h1 class="text-lg">
            {{ state.profile.name }}'s profile
            <app-badge
              v-if="!state.profile.email_verified_at"
              icon="important"
              type="neutral"
            >
              Unverified
            </app-badge>
          </h1>
        </div>
        <div class="ml-6 self-center">
          <a
            :href="route('users.index')"
            class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none mr-2"
          >
            All Users
          </a>
          <a
            :href="route('users.new')"
            class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-transparent shadow text-sm font-semibold text-white bg-primary-500 hover:bg-primary-700 hover:text-white leading-none focus:outline-none focus:shadow-outline no-underline ml-2"
          >
            Add Admin
          </a>
        </div>
      </div>
    </template>
    <template #navigation>
      <app-header>
        <template #navigation>
          <ul>
            <li
              v-for="(tab, index) in availableTabs"
              :key="index"
            >
              <a
                href="#"
                :class="{
                  'is-active': activeTab === tab.component
                }"
                @click.prevent="switchTab(tab.component)"
              >
                {{ tab.name }}
              </a>
            </li>
          </ul>
        </template>
      </app-header>
    </template>
    <keep-alive>
      <component
        :is="`User${activeTab}`"
        :state="state"
        class="mt-12"
      />
    </keep-alive>
  </app-layout>
</template>

<script>
export default {
  name: "UsersView",
  data() {
    return {
      activeTab: "Profile",
      tabs: []
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    },
    availableTabs() {
      return this.tabs.filter(tab => tab.visible);
    }
  },
  created() {
    document.title = `${this.profile.name}'s Profile :: ${document.title}`;
    this.tabs = [
      {
        name: "Profile",
        component: "Profile",
        visible: true
      },
      {
        name: "Company",
        component: "Company",
        visible: this.isVisible(this.profile.company)
      },
      {
        name: "Applications",
        component: "Applications",
        visible: this.isVisible(this.profile.applications)
      },
      {
        name: "Projects",
        component: "Projects",
        visible: this.isVisible(this.profile.competition_projects)
      },
      {
        name: "Assessments",
        component: "Assessments",
        visible: this.isVisible(this.profile.assessments)
      }
    ];
  },
  methods: {
    isVisible(obj) {
      return obj !== undefined && obj !== null;
    },
    switchTab(component) {
      this.activeTab = component;
    }
  }
};
</script>
